import { ModeResourceHelper } from '@mode/shared/util-halogen';
import { StateRecord, ApiTypes, ReportTypes } from '@mode/shared/contract-common';

export interface ReportResource extends StateRecord, ApiTypes.ModeResource {
  externalLink: string;
  account_id: number;
  account_username: string;
  archived: boolean;
  expected_runtime: number;
  created_at: string;
  published_at: string;
  color_mappings: {
    [scope: string]: {
      [seriesName: string]: number;
    };
  };
  description: string;
  drilldowns_enabled: boolean;
  drill_anywhere_enabled: boolean;
  edited_at: string;
  editLink: string;
  full_width: boolean;
  github_link?: string;
  id: string; // This is incorrect, need to change the sig of StateRecord to be more flexible
  is_embedded: boolean;
  is_signed: boolean;
  last_run_at: string;
  last_saved_at: string;
  last_successful_run_token: string;
  last_successfully_run_at: string;
  last_successful_sync_at: string;
  layout: string;
  link: string;
  manual_run_disabled: boolean;
  name: string;
  public: boolean;
  run_privately: boolean;
  shared: boolean;
  space_token: string;
  theme_id: number;
  token: string;
  updated_at: string;
  web_preview_image: string;
  query_count: number;
  chart_count: number;
  schedules_count: number;
  type: ReportTypes.ReportType;
  runs_count: number;
  view_count: number;

  _links: any[];
  _forms: {
    [key: string]: any;
  };
  _embedded: {
    [key: string]: any;
  };

  forms: (name: string) => any;
}

export interface ReportThemeResource extends StateRecord, ApiTypes.ModeResource {
  css_href: string;
  name: string;
  css_source: string;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ReportResourceHelper {
  import isResource = ModeResourceHelper.isResource;

  export function displayName(name: ReportResource['name'], type: ReportTypes.ReportType): string {
    const unnamedSlug = type === ReportTypes.ReportType.DatasetReport ? 'Untitled Dataset' : 'Untitled Report';
    return name || unnamedSlug;
  }

  export function hasBeenRun(resource: ReportResource): boolean {
    return isResource(resource) && !!resource.last_run_at;
  }

  export function isCommunity(report: ReportResource): boolean {
    return isResource(report) && report.public;
  }

  export function canEditReport(report: ReportResource): boolean {
    return isResource(report) && report.hasForm('edit');
  }

  export function canCreateReportSubscription(report: ReportResource): boolean {
    return isResource(report) && report.hasEmbedded('new_report_subscription');
  }

  export function canExportCsv(report: ReportResource): boolean {
    return isResource(report) && report.hasLink('csv_export');
  }

  export function canCreateSpaceLink(report: ReportResource): boolean {
    return isResource(report) && report.hasEmbedded('new_space_link');
  }

  export function hasFiltersLink(report: ReportResource): boolean {
    return isResource(report) && report.hasLink('report_filters');
  }

  export function canDrilldown(report: ReportResource): boolean {
    return isResource(report) && report.drilldowns_enabled;
  }
}
